// extracted by mini-css-extract-plugin
export default {"container":"login_container__q-Rb4","paper":"login_paper__jKSFJ","title":"login_title__uZDuW","subtitle":"login_subtitle__K60NT","forgetPassword":"login_forgetPassword__9Sgsu"};